export default {
  nav: { title: '靈擺' },
  categories: {
    love: { name: '感情', intro: '感情需要勇氣，也需要智慧。靈擺幫你感知內心深處已知曉的答案。', examples: ['我和TA有緣分嗎？', '這段感情值得繼續嗎？', '對方對我有特別的感情嗎？', '我們的關係會更進一步嗎？'] },
    career: { name: '事業', intro: '職場風雲變幻，靈擺感知當前能量場，為你的事業選擇提供一個直覺參考。', examples: ['這份工作適合我嗎？', '應該接受這個機會嗎？', '換工作的時機到了嗎？', '這個合作夥伴可以信任嗎？'] },
    wealth: { name: '財運', intro: '財富與時機息息相關，靈擺為你感知當前的財富能量流動方向。', examples: ['這筆投資會有回報嗎？', '近期財運順利嗎？', '適合現在創業嗎？', '這筆錢花得值當嗎？'] },
    health: { name: '健康', intro: '身體智慧往往先於意識感知，靈擺幫你傾聽自己身體發出的信號。', examples: ['身體狀況會好轉嗎？', '這種調理方法適合我嗎？', '需要改變生活方式嗎？', '這段時間要注意休養嗎？'] },
    decision: { name: '決策', intro: '重大決策往往令人迷茫，靈擺引導你接觸潛意識中已形成的判斷。', examples: ['應該選擇A方案嗎？', '這個決定是正確的嗎？', '現在是行動的好時機嗎？', '需要尋求外部幫助嗎？'] },
  },
  pendulumAnswers: {
    yes: { text: '是', subText: '正向共鳴' },
    no: { text: '暫緩', subText: '能量提示' },
    maybe: { text: '待機', subText: '時機未明' },
    unclear: { text: '重問', subText: '信號模糊' },
  },
  elements: {
    mu: { name: '木', meaning: '木行代表生發與成長之力，此時的能量場有利於新事物的開始和向上拓展。' },
    huo: { name: '火', meaning: '火行代表熱情與轉化之力，此時的能量場活躍而充滿動能，適合積極推進。' },
    tu: { name: '土', meaning: '土行代表穩固與承載之力，此時的能量場厚實而平穩，適合鞏固根基。' },
    jin: { name: '金', meaning: '金行代表收斂與精純之力，此時的能量場清晰而銳利，適合做出決斷。' },
    shui: { name: '水', meaning: '水行代表流動與智慧之力，此時的能量場靈活深沉，適合深度思考。' },
  },
  energyTypes: {
    rising: { name: '上升能量', meaning: '當前的能量場處於上升通道，適合主動出擊。' },
    stable: { name: '穩定能量', meaning: '能量場趨於平穩，適合鞏固已有成果。' },
    changing: { name: '變化能量', meaning: '能量場處於變化中，保持靈活是關鍵。' },
    purifying: { name: '淨化能量', meaning: '淨化與釋放的能量流動，適合清除阻礙。' },
    gathering: { name: '積聚能量', meaning: '能量正在積聚但未釋放，蓄勢等待時機。' },
  },
  interp: {
    love: {
      yes: { detail: '靈擺感受到雙方之間流動著真實溫暖的情感能量，彼此的心靈在某種程度上是相互呼應的。當前的緣分是真實存在的，無需過度懷疑自己的直覺。', guidance: '不必再猶豫，誠實表達內心的感受。感情需要被看見，給彼此一個真正相遇的機會。', suggestions: ['選一個放鬆的場合，坦誠分享你的感受', '關注對方發出的細微信號，它們往往比語言更真實', '珍惜現有的連接，用行動而非期待來深化感情'], timeframe: '近期（1-4週內）是推進感情的適宜窗口期。' },
      no: { detail: '靈擺感知到當前的能量場存在一些阻力，這段感情在此刻還未完全準備好。這並不意味著永久的否定，而是提示時機或方式需要重新審視。', guidance: '暫時放慢腳步，給彼此多一些空間和時間。有時候的「暫緩」是為了更好的相遇。', suggestions: ['先專注於自我提升，充實自己的內心世界', '避免強求結果，讓關係自然發展而非刻意推動', '反思是否對這段關係抱有過高或不切實際的期待'], timeframe: '建議靜候1-3個月，讓情況自然流變。' },
      maybe: { detail: '靈擺感受到模糊游移的能量，雙方之間存在可能性，但還有諸多未知變數有待明朗。此刻的不確定不是障礙，而是成長的空間。', guidance: '多與對方真實交流，了解彼此的想法和期望。清晰的溝通往往是解開迷霧的鑰匙。', suggestions: ['創造更多真實了解彼此的機會', '避免單方面胡思亂想，直接溝通勝過揣測', '審視自己內心真正想要的是什麼'], timeframe: '關鍵信息將在2-6週內逐漸浮現。' },
      unclear: { detail: '靈擺未感知到清晰的能量回應，這通常意味著提問時內心有所矛盾，或者問題本身需要更具體的聚焦。', guidance: '試著將問題細化，或者先通過獨處時光理清自己真實的內心感受後再來詢問。', suggestions: ['花時間獨處，寫下真正困擾你的具體問題', '區分清楚：這是感情問題，還是內心安全感的問題', '重新問一個更具體的問題'], timeframe: '釐清思路後隨時可以重新詢問。' },
    },
    career: {
      yes: { detail: '靈擺感受到強烈的正向能量回應，當前的機會與你的內在能量高度契合。這是一個值得把握的時機，你的直覺已經告訴你答案了。', guidance: '大膽邁出這一步。充分準備，用專業和熱情展示自己的價值，機會正在等待你去把握。', suggestions: ['儘快梳理並充分準備，以最好的狀態迎接機會', '與信任的前輩或同行深入交流，匯集更多視角', '設定清晰的階段目標，將機會轉化為實際成果'], timeframe: '此窗口期約在近1-2個月內，宜早不宜遲。' },
      no: { detail: '靈擺感知到當前這個方向存在一些不和諧的能量振動，提示此路在眼下可能並非最順暢的選擇。這是一種溫和的提醒，值得停下來多方考量。', guidance: '重新審視這個機會或決定的各個細節，尤其是你可能忽視的潛在風險點。', suggestions: ['列出這個選擇的優缺點，理性評估', '向經歷相似情況的人請教，收集多維度意見', '給自己一段時間的冷靜期，不要在情緒驅動下做決定'], timeframe: '建議靜候，當前不是推進此事的最佳時機。' },
      maybe: { detail: '靈擺感受到處於平衡狀態的能量，這件事的走向仍有較多可能性。外部條件和內部準備度都還有進一步提升的空間。', guidance: '繼續積累實力和信息，等待更多關鍵線索出現後再做最終決斷。', suggestions: ['深度研究目標方向，用更多信息消除不確定性', '在小範圍內進行試探性嘗試，降低風險', '與核心利益相關者多溝通，了解真實期待'], timeframe: '再給自己1-3個月的信息收集和準備時間。' },
      unclear: { detail: '能量信號模糊，通常是因為當前對這件事的了解還不夠全面，或內心存在矛盾。', guidance: '先深入了解更多具體情況，將模糊的想法轉化為清晰的問題再來詢問。', suggestions: ['明確具體要問的是哪個環節的決策', '整理已知信息和未知疑問', '可分拆為多個小問題逐一確認'], timeframe: '待信息明朗後再詢問。' },
    },
    wealth: {
      yes: { detail: '靈擺感受到財富能量正在向你流動的方向振動，當前的財運狀態較為順暢，有利於推進相關計劃。直覺提示這是一個相對有利的時機。', guidance: '以冷靜的頭腦把握當前機會，理性決策比憑運氣更能讓好運持續。', suggestions: ['做好詳細的財務規劃，明確風險承受底線', '保留一定的流動資金，不可全部押注', '尋求專業人士的意見，讓好運更穩固'], timeframe: '近1-2個月財運較為順暢。' },
      no: { detail: '靈擺感知到當前財富能量流動不夠順暢，此刻冒進可能帶來不必要的損耗。這是一個提示你審慎的信號。', guidance: '暫緩激進的財務決策，以守為攻，先做好風險管控。', suggestions: ['暫緩大額投資或不熟悉領域的嘗試', '梳理當前財務狀況，排查潛在漏洞', '把精力放在穩固現有收入來源上'], timeframe: '建議待時機明朗後（1-3個月）再推進。' },
      maybe: { detail: '財運能量處於平衡點，進退兩可。這件事有一定可能性，但成敗很大程度上取決於執行細節和時機的把握。', guidance: '做好充分的可行性評估，降低不確定性後再決定是否推進。', suggestions: ['進行小規模試水，觀察實際效果', '做詳細的收益風險比分析', '多了解同類案例，避免重蹈覆轍'], timeframe: '觀察1-2個月市場變化後再行動更穩妥。' },
      unclear: { detail: '財務問題往往需要非常具體的方向才能得到清晰回應，當前信號模糊提示問題可能過於寬泛。', guidance: '將財務問題具體化，例如針對某一特定項目或金額來詢問。', suggestions: ['將問題具體到某一項投資或決策', '先整理清楚自己的財務目標', '可以分幾個維度分別詢問'], timeframe: '問題具體化後隨時可重新詢問。' },
    },
    health: {
      yes: { detail: '靈擺感受到你的身體能量正處於積極恢復和上升的狀態，當前的調理方向或身體感知是真實可信的。好好配合身體的自我修復節奏。', guidance: '保持當前的健康習慣，並在此基礎上進一步深化，讓好的狀態延續。', suggestions: ['繼續堅持當前有效的調理或鍛煉方式', '充足睡眠是最強效的健康投資，優先保證', '記錄身體的細微變化，及時調整細節'], timeframe: '當前調理方向正確，堅持2-4週可見明顯改善。' },
      no: { detail: '靈擺感知到身體能量場存在一些不平衡，提示當前的狀態需要更多關注和調整。這是身體在溫和地向你發出信號，請認真傾聽。', guidance: '優先關注休息和自我調養，不要忽視身體發出的任何信號，必要時尋求專業健康指導。', suggestions: ['保證充足睡眠和規律作息，這是基礎中的基礎', '減少當前的壓力來源，給身心留出喘息空間', '若有持續不適，請及時諮詢專業醫生'], timeframe: '當下是休養調整的重要時機，不宜硬撐。' },
      maybe: { detail: '身體能量信號處於波動中，調理效果存在變數。影響健康的因素是多方面的，生活方式的整體調整可能比單一方法更有效。', guidance: '從多個角度綜合調整：睡眠、飲食、運動、情緒，尋找適合自己的平衡點。', suggestions: ['觀察不同調理方式對自己的實際效果差異', '記錄飲食和睡眠日記，找到影響狀態的規律', '從最容易改變的一個生活習慣開始優化'], timeframe: '堅持綜合調整2-3週後再評估效果。' },
      unclear: { detail: '健康類問題有時需要更聚焦的詢問方向才能得到清晰的能量回應。', guidance: '將問題聚焦於具體症狀或具體調理方案，而非泛泛詢問整體健康。', suggestions: ['針對具體的不適或調理方法來詢問', '先做一次系統的健康自檢', '結合專業醫療建議，不要僅依賴直覺占卜'], timeframe: '明確問題後隨時可重新詢問。' },
    },
    decision: {
      yes: { detail: '靈擺感受到你的內在智慧已經做出了判斷，這個決定與你的內心方向是一致的。直覺往往是潛意識對大量信息綜合處理後的結果，值得信任。', guidance: '已經分析足夠多了，是時候行動了。做好應對各種結果的準備，然後堅定地邁出這一步。', suggestions: ['制定清晰的行動計劃，將決定轉化為具體步驟', '做好預案：若結果偏離預期，有什麼調整方案', '告知身邊可以支持你的人，借助外力助力成功'], timeframe: '當前是推進這一決策的有利時機。' },
      no: { detail: '靈擺感知到內在有某些未解決的顧慮在阻礙能量流動，提示當前這個決定可能還不夠完善，或者時機尚未成熟。', guidance: '在下決定之前，找出那個隱約讓你不安的點，認真對待它而不是壓制它。', suggestions: ['列出所有未解決的疑慮，逐一認真評估', '與最了解你的人深度交流，聽聽他們的看法', '給自己設定一個「冷靜期」，避免在情緒波動時做重大決定'], timeframe: '建議再給自己1-4週的充分考量時間。' },
      maybe: { detail: '靈擺感受到正反兩股能量勢均力敵，這個決策確實存在多種可能性。當前的不確定性是真實的，需要更多信息才能傾斜。', guidance: '先把能確認的事項一一落實，縮小不確定的範圍，讓決策變得更清晰。', suggestions: ['把不確定因素列出來，看看哪些是可以主動去確認的', '設定一個最終決策的截止日期，避免無限期拖延', '考慮最壞和最好的結果，測試自己是否都能接受'], timeframe: '設定明確的決策期限，避免拖延帶來的機會成本。' },
      unclear: { detail: '決策類問題最需要清晰的聚焦，當前信號模糊通常是因為在一個問題中同時考量了太多因素。', guidance: '將複雜決策拆解為若干個獨立的子問題，逐一明確，再匯總判斷。', suggestions: ['把大決策拆解為若干小問題', '對每個關鍵變量單獨詢問', '先解決最核心的那個疑問'], timeframe: '問題拆解清楚後隨時可重新詢問。' },
    },
  },
  closingNotes: {
    0: '靈擺是傾聽內心潛意識的工具，答案本就在你心中。命運由你自己書寫，占卜只是鏡子，映照你內心已有的智慧。',
    1: '無論靈擺如何指引，真正的主動權始終在你手中。把這個結果作為思考的起點，而非最終答案。',
    2: '占卜是認識自我的工具，而非束縛命運的枷鎖。以開放的心態看待這個提示，結合理性判斷做出屬於自己的選擇。',
  },
  dial: { yes: '是', standby: '待機', slow: '暫緩' },
  state: {
    emptyPrompt: '請先輸入完整問題，再啟動靈擺',
    awaitingConsent: '首次使用需先確認聲明，請查看彈窗提示',
    sensing: '靈擺感知中，請靜心專注…',
    sensingTitle: '正在感應',
    generatingTitle: '正在生成判讀',
    completeTitle: '判讀完成',
    waiting: '點擊下方問題，等待靈擺指引',
    consentFlash: '聲明已確認，靈擺啟動中…',
  },
  input: { placeholder: '點擊選擇心中所問' },
  btn: {
    start: '啟動靈擺',
    startHint: '輸入問題後點擊啟動',
    sensing: '靈擺感知中…',
    reask: '重新詢問',
    emptyHint: '請先輸入問題',
    consentHint: '請先同意聲明',
  },
  result: {
    responseTitle: '靈擺回應 · {{subText}}',
    signalStrength: '信號強度',
    confidence: '{{n}}%',
    catType: '{{cat}}類問題',
  },
  
  sections: {
    interpret: '判讀解讀',
    action: '行動指引',
    timing: '時機建議',
    energy: '能量分析',
    structure: '問題結構分析',
    tendency: '信號傾向',
    uncertainty: '不確定來源',
    actions: '可做動作',
    reask: '重問建議',
    badgeDetail: '詳析',
    badgeSuggest: '建議',
    badgeStructure: '結構層',
    badgeTendency: '判讀層',
    doThis: '具體可以這樣做：',
    deepAnalysis: '深度解析',
    timingAbout: '關於時機建議',
    timingAboutText: '時機建議基於當前問題結構分析，並非絕對預言。隨著資訊的變化和實際條件的演進，時機判讀結果也可能改變。',
    wuxingTitle: '什麼是五行能量',
    wuxingDesc: '五行（木火土金水）是中國傳統哲學對宇宙能量的分類描述。',
    wuxingLabel: '五行屬性',
    currentLabel: '當前能量',
  },
  interpret: {
    yes: '此刻的正向回應，說明你內心深處對此事持開放接納的態度，潛意識已為行動做好了準備。',
    no: '此刻的暫緩信號，並非永久否定，而是你潛意識在提醒你：當前存在某些未被意識到的顧慮值得重視。',
    maybe: '游移的擺動反映了你內心真實的矛盾狀態，兩股方向相近的力量在同時作用，需要更多的信息來打破平衡。',
    unclear: '信號模糊通常意味著你對這個問題本身還沒有清晰的認知框架，先釐清問題比得到答案更重要。',
  },
  energy: {
    mu: '木行代表生發與成長之力，此時的能量場有利於新事物的開始和向上拓展。',
    huo: '火行代表熱情與轉化之力，此時的能量場活躍而充滿動能，適合積極推進。',
    tu: '土行代表穩固與承載之力，此時的能量場厚實而平穩，適合鞏固根基。',
    jin: '金行代表收斂與精純之力，此時的能量場清晰而銳利，適合做出決斷。',
    shui: '水行代表流動與智慧之力，此時的能量場靈活深沉，適合深度思考。',
  },
  intro: {
    title: '何為靈擺',
    desc: '靈擺是一種古老的直覺探索工具，其原理是借助潛意識的微妙肌肉反應，將內心已形成的感知轉化為可觀察的擺動方向。它不是魔法，而是一面映照內心的鏡子。',
    scienceTitle: '科學原理',
    scienceDesc: '靈擺效應的核心是「意念肌動效應」（Ideomotor Effect）——當人的潛意識對某個問題已有傾向時，手部肌肉會產生極其細微的、無意識的運動，放大後形成擺動。這不是神秘現象，而是潛意識通過身體傳遞信號的方式。',
    tipsTitle: '使用要點',
    tip0: '提問時保持內心平靜，專注於問題本身',
    tip1: '問題需具體明確，避免模糊或雙重含義',
    tip2: '重要決策請結合理性分析，不宜單憑直覺',
    tip3: '靈擺是認識自我的工具，非命運的裁判',
  },
  directions: { title: '可詢問的方向' },
  answers: {
    title: '靈擺的四種回應',
    yes: '內在能量正向共鳴，時機與方向均較為順暢。潛意識已做好準備，可以積極推進。',
    no: '能量場提示暫緩審視，宜停下來檢視顧慮，而非強行推進。',
    maybe: '時機尚未完全明朗，兩股力量勢均力敵，需更多信息才能傾斜判斷。',
    unclear: '問題需更聚焦具體，釐清核心訴求後重新詢問效果更佳。',
  },
  disclaimer: {
    title: '使用須知',
    subtitle: '請在繼續前閱讀以下聲明',
    body: '本功能及其內容信息僅供娛樂參考，不等同於專業心理測評或任何學科的專業意見，不代表價值判斷，亦不具有任何現實指導意義。',
    item0: '結果不能代替醫療、法律、心理等專業諮詢',
    item1: '請勿將占卜結果作為重大決策的依據',
    item2: '保持理性，娛樂使用，愉悅自己',
    cancel: '取消',
    confirm: '我已了解，繼續',
  },
  share: {
    title: '分享占卜結果',
    hint: '長按圖片即可保存到相冊',
    generating: '正在生成結果卡片…',
    failed: '生成失敗，請重試',
    retry: '重新生成',
    close: '關閉',
    save: '保存圖片',
  },
  shareCard: {
    response: '── 靈擺回應 ──',
    signalPct: '信號強度 {{n}}%',
    askLabel: '所問之事',
    catLabel: '類別',
    energyLabel: '能量',
    wuxingLabel: '五行',
    guidanceLabel: '靈擺指引',
    disclaim: '本結果僅供娛樂參考，不代表任何現實指導意義',
    brand: '靈擺',
  },
  emptyAlert: {
    badge: '必選',
    title: '請先選擇問題',
    desc: '點擊下方示例問題，或在輸入框中輸入你想問的問題',
    confirm: '知道了',
  },
  structure: {
    questionType: '問題類型',
    clarityLabel: '清晰度評分',
    clarityUnit: '分',
    missingInfo: '前提資訊不足',
  },
  tendency: {
    riskLabel: '風險傾向',
  },
  process: {
    step1: '確認問題',
    step2: '感應信號',
    step3: '生成判讀',
    step4: '完成判讀',
  },
};
